



























import { Prop, Component, Vue, Inject, Watch } from "vue-property-decorator";
import ID from "../../ID";
import AbcToolButton from "../button/AbcToolButton.vue";

@Component({
    components: {
        AbcToolButton,
    },
})
export default class AbcAccordion extends Vue {
    @Prop() value!: boolean;
    @Prop() title!: string;
    @Prop() id!: string;
    @Prop() forceUpdate!: number;

    private contentStyle = {
        opacity: 0,
        "max-height": "0px",
    };

    mounted() {
        this.computeContentStyle();
    }

    private get myId() {
        return this.id || ID.next();
    }

    private get isOpen() {
        return this.value;
    }

    private set isOpen(val: boolean) {
        this.$emit("input", val);
    }

    @Watch("forceUpdate")
    @Watch("isOpen")
    private onUpdate(){
        this.$nextTick(() => this.computeContentStyle());
    }

    private computeContentStyle() {
        const el = document.getElementById(this.myId + "_accordion_content");
        if (this.isOpen) {
            this.contentStyle = {
                "max-height": el && el.scrollHeight ? el.scrollHeight + "px" : "100%",
                opacity: 1,
            };
        } else {
            this.contentStyle = {
                opacity: 0,
                "max-height": "0px",
            };
        }
    }

    private get titleClass() {
        return {
            "duration-500 rounded-lg ": !this.isOpen,
            "duration-400 rounded-t-lg": this.isOpen,
        };
    }
}
